import { render, staticRenderFns } from "./abrir-fechar-anolectivo.vue?vue&type=template&id=4c42be21&"
import script from "./abrir-fechar-anolectivo.vue?vue&type=script&lang=js&"
export * from "./abrir-fechar-anolectivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports